import { getApiClient } from "../client";
import { USER_POPULATE } from "../populate";
import { DisableVipInputSchema, DisableVipResponseSchema, StrapiIdSchema, TaxProfileMigrationStatusSchema, UserConsentSchema, UserSchema, UsersQueryParamsSchema, UserUpdateInputSchema, validateInput, validateResponse, } from "../schemas";
import { parseStrapiItemResponse, parseStrapiListResponse } from "../utils/parseStrapiResponse";
export const usersEndpoints = {
    async getMe(params) {
        const populate = params?.populate ?? USER_POPULATE.FULL;
        const response = await getApiClient().get("/users/me", {
            params: { populate },
        });
        return parseStrapiItemResponse(response.data, {
            schema: UserSchema,
            populate,
            context: "usersEndpoints.getMe",
        });
    },
    async getUser(id, params) {
        const validatedId = validateInput(StrapiIdSchema, id, "usersEndpoints.getUser");
        const populate = params?.populate ?? USER_POPULATE.FULL;
        const response = await getApiClient().get(`/users/${validatedId}`, {
            params: { populate },
        });
        return parseStrapiItemResponse(response.data, {
            schema: UserSchema,
            populate,
            context: "usersEndpoints.getUser",
        });
    },
    async getUsers(params) {
        const validated = params ? validateInput(UsersQueryParamsSchema, params, "usersEndpoints.getUsers") : undefined;
        const populate = params?.populate ?? USER_POPULATE.LIST;
        const response = await getApiClient().get("/users", {
            params: {
                populate,
                ...validated,
            },
        });
        return parseStrapiListResponse(response.data, {
            schema: UserSchema,
            populate,
            context: "usersEndpoints.getUsers",
        });
    },
    async updateMe(data) {
        const validated = validateInput(UserUpdateInputSchema, data, "usersEndpoints.updateMe");
        const response = await getApiClient().put("/users/me", validated);
        return parseStrapiItemResponse(response.data, {
            schema: UserSchema,
            context: "usersEndpoints.updateMe",
        });
    },
    async updateUser(id, data) {
        const validatedId = validateInput(StrapiIdSchema, id, "usersEndpoints.updateUser");
        const validated = validateInput(UserUpdateInputSchema, data, "usersEndpoints.updateUser");
        const response = await getApiClient().put(`/users/${validatedId}`, validated);
        return parseStrapiItemResponse(response.data, {
            schema: UserSchema,
            context: "usersEndpoints.updateUser",
        });
    },
    async getTaxProfileMigrationStatus() {
        const response = await getApiClient().get("/users/me/tax-profile-migration-status");
        return parseStrapiItemResponse(response.data, {
            schema: TaxProfileMigrationStatusSchema,
            context: "usersEndpoints.getTaxProfileMigrationStatus",
        });
    },
    async disableVip(input) {
        const validated = validateInput(DisableVipInputSchema, input, "usersEndpoints.disableVip");
        const { userId, billingPeriodStart, subscriptionTierId } = validated;
        const response = await getApiClient().put(`/users/${userId}/disable-vip`, {
            billingPeriodStart,
            subscriptionTierId,
        });
        // The response is not wrapped in Strapi format, validate directly
        const validatedResponse = validateResponse(DisableVipResponseSchema, response.data, {
            context: "usersEndpoints.disableVip",
        });
        return { data: validatedResponse, meta: {} };
    },
    async getMyConsents() {
        const response = await getApiClient().get("/users/me/consents");
        return parseStrapiItemResponse(response.data, {
            schema: UserConsentSchema,
            context: "usersEndpoints.getMyConsents",
        });
    },
    async updateMyConsents(consents) {
        const response = await getApiClient().put("/users/me/consents", consents);
        return parseStrapiItemResponse(response.data, {
            schema: UserConsentSchema,
            context: "usersEndpoints.updateMyConsents",
        });
    },
    async getUserConsents(userId) {
        const validatedId = validateInput(StrapiIdSchema, userId, "usersEndpoints.getUserConsents");
        const response = await getApiClient().get(`/users/${validatedId}/consents`);
        return parseStrapiItemResponse(response.data, {
            schema: UserConsentSchema,
            context: "usersEndpoints.getUserConsents",
        });
    },
    async updateUserConsents(userId, consents) {
        const validatedId = validateInput(StrapiIdSchema, userId, "usersEndpoints.updateUserConsents");
        const response = await getApiClient().put(`/users/${validatedId}/consents`, consents);
        return parseStrapiItemResponse(response.data, {
            schema: UserConsentSchema,
            context: "usersEndpoints.updateUserConsents",
        });
    },
    async confirmRemoval(token) {
        const response = await getApiClient().post("/users/me/confirm-remove", {
            token,
        });
        return parseStrapiItemResponse(response.data);
    },
};
